import React from 'react';
import { MessageCircle, Users } from 'lucide-react';
interface ChatToggleProps {
  activeChat: 'chat' | 'group_chat';
  onToggle: (chat: 'chat' | 'group_chat') => void;
}
export const ChatToggle: React.FC<ChatToggleProps> = ({
  activeChat,
  onToggle
}) => {
  return <div className="flex items-center bg-of-gray dark:bg-gray-800 rounded-md overflow-hidden" data-id="element-3268">
      <button className={`flex items-center gap-1.5 px-4 py-2 text-sm ${activeChat === 'chat' ? 'bg-of-blue dark:bg-faded-purple text-white' : 'text-of-text-secondary dark:text-gray-400 hover:text-of-text-primary dark:hover:text-white'}`} onClick={() => onToggle('chat')} data-id="element-3269">
        <MessageCircle size={14} data-id="element-3270" />
        <span data-id="element-3271">Private</span>
      </button>
      <button className={`flex items-center gap-1.5 px-4 py-2 text-sm ${activeChat === 'group_chat' ? 'bg-of-blue dark:bg-faded-purple text-white' : 'text-of-text-secondary dark:text-gray-400 hover:text-of-text-primary dark:hover:text-white'}`} onClick={() => onToggle('group_chat')} data-id="element-3272">
        <Users size={14} data-id="element-3273" />
        <span data-id="element-3274">Playroom</span>
      </button>
    </div>;
};